import '../q.css'

import { useEffect, useState } from "react";
import axios from "axios";
import MigationPopup from './Popup/MigationPopup';
import { useNavigate, useParams } from 'react-router-dom';
import SharedRegionProviderOverlay from '../SharedRegionProviderOverlay';

const Heading = ({ icon, text }) => {
    return (
        <div className='s-block-heading'>
            {icon} {text}
        </div>
    )
}

const Button = ({ text, onClick, disabled = false }) => {
    return (<button className='t-copy-btn' disabled={disabled} onClick={onClick}>
        {text}
    </button>)
}

const CopyButton = ({ copyValue, text, activeText = "✅ Скопировано" }) => {

    const [isCopied, setCopied] = useState(false);

    const copyToClipboard = (event) => {
        event.preventDefault();
        navigator.clipboard.writeText(copyValue);
        setCopied(true);
    }

    useEffect(() => {
        if (isCopied) {
            setTimeout(() => {
                setCopied(false);
            }, 3500)
        }
    }, [isCopied])

    return (<Button onClick={copyToClipboard} text={isCopied ? activeText : text} />)
}


const TButton = ({ text, onClick, disabled = false }) => {
    return (<button className='t-copy-data-btn' disabled={disabled} onClick={onClick}>
        {text}
    </button>)
}

const TCopyButton = ({ copyValue, text, activeText = "✅ Скопировано" }) => {

    const [isCopied, setCopied] = useState(false);

    const copyToClipboard = (event) => {
        event.preventDefault();
        navigator.clipboard.writeText(copyValue);
        setCopied(true);
    }

    useEffect(() => {
        if (isCopied) {
            setTimeout(() => {
                setCopied(false);
            }, 3500)
        }
    }, [isCopied])

    return (<TButton onClick={copyToClipboard} text={isCopied ? activeText : text} />)
}

export { Button, Heading, CopyButton, TButton, TCopyButton };

export default function Key() {

    const { id } = useParams();

    const [pageState, setPageState] = useState('search');
    const [userKeyID, setUserKeyID] = useState('');
    const [prolongationDays, setProlongationDays] = useState(0);

    // States and updates
    const [isCreatingBackupKey, setCreatingBackupKey] = useState(false);
    const [isMigrationOverlayOpened, setMigrationOverlayOpened] = useState(false);
    const [isArchieveingKey, setArchieveingKey] = useState(false);
    const [archieveSafetyCounter, setArchieveSafetyCounter] = useState(0);

    const [isDeletingBackupKey, setDeletingBackupKey] = useState(false);
    const [isProlongationOverlayOpened, setProlongationOverlayOpened] = useState(false);
    const [isProlongationLoading, setProlongationLoading] = useState(false);
    const [databaseKey, setDatabaseKey] = useState(null);

    const [isProviderAndRegionOverlayOpened, setProviderAndRegionOverlayOpened] = useState(false);
    const [databaseRegion, setDatabaseRegion] = useState(null);
    const [databaseProvider, setDatabaseProvider] = useState(null);


    const [migrationHistory, setMigrationHistory] = useState([]);

    const navigate = useNavigate();

    const getPlan = (plan) => {
        const n = parseInt(plan);
        if (n === 0) {
            return 'Базовый';
        }
        if (n === 1) {
            return 'Премиум';
        }
        if (n === 2) {
            return 'Deeplink';
        }
        if (n === 3) {
            return 'Семейный 6м';
        }
        if (n === 15) {
            return 'Семейный год';
        }
        if (n === 4) {
            return 'Базовый 🇬🇧';
        }
        if (n === 5) {
            return 'Базовый 🇫🇮';
        }
        if (n === 6) {
            return 'Базовый 🇩🇪';
        }
        if (n === 10) {
            return 'Базовый 🇺🇸';
        }
        if (n === 7) {
            return 'Базовый Yota';
        }
        if (n === 11) {
            return 'Семейный Yota';
        }
        if (n === 8) {
            return 'Семейный 🇬🇧';
        }
        if (n === 9) {
            return 'Семейный 🇫🇮';
        }
        if (n === 13) {
            return 'Семейный 🇩🇪';
        }
        if (n === 14) {
            return 'Семейный 🇺🇸';
        }
        if (n === 12) {
            return 'Russia';
        }
        if (n === 99) {
            return 'Триальный';
        }

        if (n === 20) {
            return 'Я в Китае';
        }
        if (n === 21) {
            return 'Я в Китае / 6м';
        }
        if (n === 30) {
            return 'Бизнес';
        }

        return '';
    };

    const formatDate = (dateObject) => {
        return ("0" + dateObject.getDate()).slice(-2) + "." +
            ("0" + (dateObject.getMonth() + 1)).slice(-2) + "." +
            dateObject.getFullYear();
    }

    const makeOutlineBackupKey = async () => {
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        const data = {
            key: databaseKey.id,
        };
        console.log({ data });
        try {
            setCreatingBackupKey(true);
            const req = await axios.post('https://sasovo.cdn-yandex.net/v4/backupOutlineKey', data, { headers: { Authorization: `Bearer ${token}` } });
            if (req.data.ok) {
                searchKey();
            } else {
                alert('Something went wrong');
            }
            setCreatingBackupKey(false);
        } catch (e) {
            console.log({ e });
        }
    };

    const deleteOutlineKey = async () => {
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        // deleteOutlineKey
        const data = {
            key: databaseKey.id,
        };
        console.log({ data });
        try {
            setDeletingBackupKey(true);
            const req = await axios.post('https://sasovo.cdn-yandex.net/v4/deleteOutlineKey', data, { headers: { Authorization: `Bearer ${token}` } });
            if (req.data.ok) {
                searchKey();
            } else {
                alert('Something went wrong');
            }
            setDeletingBackupKey(false);
        } catch (e) {
            console.log({ e });
        }
    }

    const archieveKey = async () => {
        if (isArchieveingKey) { return }
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        try {
            let _id = userKeyID
            if (_id === '' || _id === undefined || _id === null) {
                _id = id
            }
            setArchieveingKey(true)

            const req = await axios.post("https://sasovo.cdn-yandex.net/v4/archive-user-key", { id: _id }, { headers: { Authorization: `Bearer ${token}` } });
            if (req.data.ok) {
                await searchKey();
            } else {
                alert('Something went wrong');
            }
            setArchieveingKey(false);
            setArchieveSafetyCounter(0);
        } catch (e) {
            console.log(e);
            alert("Something went wrong");
        }
    }

    const clearInformation = () => {
        window.location = '/key';
    }

    useEffect(() => {
        if (archieveSafetyCounter === 5) {
            archieveKey();
        }
    }, [archieveSafetyCounter])

    useEffect(() => {
        if (id !== null && id !== undefined) {
            if (id.length > 0) {
                searchKeyByID(id)
            }
        }
    }, [id])

    const decodeCustom = (encodedStrURL) => {
        // First, replace the percent-encoded characters back to their original form

        const URLCleanup = encodedStrURL.replace("https://s3.amazonaws.com/outline-vpn/invite.html#", "");
        const decodedStr = URLCleanup.replace(/%21|%27|%28|%29|%2A/g, function (match) {
            switch (match) {
                case '%21':
                    return '!';
                case '%27':
                    return "'";
                case '%28':
                    return '(';
                case '%29':
                    return ')';
                case '%2A':
                    return '*';
            }
        });

        // Then, use decodeURIComponent to decode the rest of the string
        return decodeURIComponent(decodedStr);
    }

    const searchKey = async () => {
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        console.log({ userKeyID })
        let _id = userKeyID
        if (_id === '' || _id === undefined || _id === null) {
            _id = id
        }
        const request = await axios.post('https://sasovo.cdn-yandex.net/v4/get-user-key', { id: _id }, { headers: { Authorization: `Bearer ${token}` } });
        const { data } = request;
        console.log({ data })
        const { key } = data;
        setDatabaseKey(key);
        setPageState('response');
        setDatabaseProvider(data.regionAndProvider.provider);
        setDatabaseRegion(data.regionAndProvider.region);


        if (data.history) {
            console.log({ history: data.history })
            setMigrationHistory(data.history)
        }
    }

    const searchKeyByID = async (localeID) => {
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        const request = await axios.post('https://sasovo.cdn-yandex.net/v4/get-user-key', { id: localeID }, { headers: { Authorization: `Bearer ${token}` } });
        const { data } = request; console.log({ data })
        const { key } = data;
        if (data.ok === false) {
            alert("Ключ не найден");
            navigate('/key')
            return;
        }


        setDatabaseKey(key);
        setPageState('response');

        setDatabaseProvider(data.regionAndProvider.provider);
        setDatabaseRegion(data.regionAndProvider.region);

        if (data.history) {
            setMigrationHistory(data.history)
        }
    }

    const shortenIdForMobile = (processingId) => {
        const id = String(processingId);
        const idStart = id.slice(0, 4);
        const idInBetween = '...';
        const idEnd = id.slice(id.length - 4, id.length);
        return `${idStart}${idInBetween}${idEnd}`;
    }

    const prolongateKey = async () => {
        if (parseInt(prolongationDays) < 1) {
            return;
        }
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        setProlongationLoading(true);
        const data = {
            key: databaseKey.id,
            days: prolongationDays,
        };

        try {
            const req = await axios.post("https://sasovo.cdn-yandex.net/v4/prolongateKey", data, { headers: { Authorization: `Bearer ${token}` } });
            if (req.data.ok) {
                await searchKey();
            } else {
                alert('Something went wrong');
            }
            setProlongationDays(0);
            setProlongationLoading(false);
            setProlongationOverlayOpened(false);
        } catch (e) {
            console.log(e);
            alert("Something went wrong");
        }
    }


    const validateUserKey = (event) => {
        if (event.target.value === '') {
            return;
        }
        let key = String(event.target.value);
        let keyId = '';

        if (String(key).includes('?q=')) {
            const array = key.split('?q=');
            key = array[0];
        }

        if (String(key).includes('https://shared.simplesmm.org/')) {
            const validKey = String(key);
            keyId = validKey.split('https://shared.simplesmm.org/')[1];
            navigate(`/switch/${keyId}`)
        }

        if (String(key).includes('https://key.simplesmm.org/')) {
            const validKey = String(key);
            keyId = validKey.split('https://key.simplesmm.org/')[1];
            // setUserKeyID(keyId);
            navigate(`/switch/${keyId}`)
        }

        if (String(key).includes('https://key.simplesmm.org/')) {
            const validKey = String(key);
            keyId = validKey.split('https://key.simplesmm.org/')[1];
            navigate(`/switch/${keyId}`)
        }

        if (String(key).includes('https://bot.simplesmm.org/')) {
            const validKey = String(key);
            keyId = validKey.split('https://bot.simplesmm.org/')[1];
            navigate(`/switch/${keyId}`)
        }

        if (String(key).includes("https://config.x.simplesmm.org/")) {
            const validKey = String(key);
            keyId = validKey.split('https://config.x.simplesmm.org/')[1];
            navigate(`/switch/${keyId}`)
        }

        if (String(key).includes("https://key.simpletg.org/")) {
            const validKey = String(key);
            keyId = validKey.split('https://key.simpletg.org/')[1];
            navigate(`/switch/${keyId}`)
        }

        if (String(key).includes("https://conf.simpletg.org/")) {
            const validKey = String(key);
            keyId = validKey.split('https://conf.simpletg.org/')[1];
            navigate(`/switch/${keyId}`)
        }

        if (String(key).includes("https://tavukdurum.simplebotpro.ru/")) {
            const validKey = String(key);
            keyId = validKey.split('https://tavukdurum.simplebotpro.ru/')[1];
            navigate(`/switch/${keyId}`)
        }
    };

    const configurationEndpointURLs = {
        default: databaseKey === null ? "" : "ssconf://c.simplesmm.org/" + databaseKey.id + "#SimpleVPN / " + getPlan(databaseKey.plan),
        mirror: databaseKey === null ? "" : "https://tavukdurum.simplebotpro.ru/" + databaseKey.id + "#SimpleVPN / " + getPlan(databaseKey.plan)
    }

    if (pageState === 'response') {
        return (
            <>
                {isMigrationOverlayOpened && <MigationPopup
                    keyID={databaseKey.id}
                    migrationHistory={migrationHistory}
                    plan={databaseKey.plan}
                    close={() => setMigrationOverlayOpened(false)}
                    currentServer={databaseKey.configuration.server}
                    currentServerComment={databaseKey.comment}
                    reload={() => {
                        searchKey();
                        setMigrationOverlayOpened(false);
                    }} />}

                {isProviderAndRegionOverlayOpened && <>
                    <SharedRegionProviderOverlay
                        chat_id={databaseKey.user_id}
                        region={databaseRegion}
                        setRegion={setDatabaseRegion}
                        provider={databaseProvider}
                        setProvider={setDatabaseProvider}
                        close={() => {
                            setProviderAndRegionOverlayOpened(false);
                            searchKey();
                        }}
                    />
                </>}
                {isProlongationOverlayOpened && (<div className='overlay'>
                    <div className='overlay-content'>
                        <div>Продляем ключ на количество дней</div>
                        <input type='number' className='t-input' value={prolongationDays} min={0} onChange={e => setProlongationDays(e.target.value)} placeholder='На сколько дней?'></input>
                        <button className='t-button' disabled={isProlongationLoading} onClick={prolongateKey}>{isProlongationLoading ? '⏳ Изменяем ход времени...' : "Продлить"}</button>
                        <button className='t-button' onClick={() => setProlongationOverlayOpened(false)}>Закрыть</button>
                    </div>
                </div>)}
                <div className="content-block t-container">
                    <div className="page-header">
                        <div></div>
                        <button className='t-close-page-btn' onClick={() => { navigate('/') }}>
                            ❌
                        </button>
                    </div>
                    <div className='t-updated-content'>
                        <Heading icon={'🧍🏻'} text={'Пользователь'} />
                        <div className='t-data-double' onClick={() => navigate('/user/' + databaseKey.user_id)}>
                            <div className='t-data-block pointer'>@{databaseKey.username}</div>
                            <div className='t-data-block pointer'>{databaseKey.user_id}</div>
                        </div>
                        <div className='t-data-double'>
                            <div className='t-data-block'>{databaseRegion !== '' ? databaseRegion : "Регион не установлен"}</div>
                            <div className='t-data-block'>{databaseProvider !== '' ? databaseProvider : "Провайдер не установлен"}</div>
                        </div>
                        <TButton disabled={false} onClick={() => {
                            setProviderAndRegionOverlayOpened(true)
                        }} text={"⚙️ Регион / Оператор"} />
                        <Heading icon={'🔑'} text={"Ключ " + shortenIdForMobile(databaseKey.id)} />
                        {databaseKey.is_active === false && <span className='t-data-block error'>Ключ не активен</span>}
                        <div className='t-data-double'>
                            <div className='t-data-block small'><b>{"Outline"} / {getPlan(databaseKey.plan)}</b></div>
                            <div className='t-data-block small'>{getPlan(databaseKey.plan)}</div>
                        </div>

                        <div className='t-data-double'>
                            <TCopyButton text={'✏️ Ссылка'} copyValue={`https://shared.simplesmm.org/${databaseKey.id}?q=${getPlan(databaseKey.plan)}`} />
                            <TCopyButton text={'🪞 Ссылка'} copyValue={`https://key.simpletg.org/${databaseKey.id}?q=${getPlan(databaseKey.plan)}`} />
                        </div><div className='t-data-double'>
                            <TCopyButton text={'✏️ Конфигурация'} copyValue={"`" + configurationEndpointURLs.default + "`"} />
                            <TCopyButton text={'🪞 Конфигурация'} copyValue={"`" + configurationEndpointURLs.mirror + "`"} />
                        </div>
                        <div className='t-data-double'>
                            {
                                databaseKey.outline_backup_link === null &&
                                <TButton text={!isCreatingBackupKey ? "🪨 Создать статику" : "⏳ Создаем ключ..."} disabled={isCreatingBackupKey} onClick={makeOutlineBackupKey} />}
                            <TButton
                                disabled={isArchieveingKey}
                                onClick={() => {
                                    if (archieveSafetyCounter === 5) {
                                        return;
                                    }
                                    setArchieveSafetyCounter(archieveSafetyCounter + 1);
                                }}
                                text={isArchieveingKey ? "⏳ Архивируем ключ..." : archieveSafetyCounter === 0 ? "⚠️ Архивировать" : `🚨 Нажмите ${5 - archieveSafetyCounter} раз`} />
                        </div>

                        {/* </div> */}
                        {databaseKey.proxy_backup_link !== null && <>
                            <Heading icon={'🛠️'} text={'Статический ключ ( Старая версия )'} />
                            <div className='t-data-double'>
                                <TCopyButton text={'Конфигурация ss://'} copyValue={decodeCustom(databaseKey.proxy_backup_link)} />
                                <TButton text={isDeletingBackupKey ? "⏳ Удаляем..." : "Удалить статику"} disabled={isDeletingBackupKey} onClick={deleteOutlineKey} />
                            </div>
                        </>}
                        <Heading icon={'⏰'} text={'Время действия'} />
                        <div className='t-data-double'>
                            <div className='t-data-block'>{formatDate(new Date(databaseKey.expire_date))}</div>
                            <TButton disabled={false} text={"Продлить"} onClick={() => setProlongationOverlayOpened(true)} />
                        </div>


                        <Heading icon={'🕸️'} text={'Сервер'} />
                        {databaseKey.is_proxy_enabled && <div className='t-data-block proxy'>🧭 {databaseKey.proxy_ip} {databaseKey.proxy_port !== '0' && databaseKey.proxy_port !== '0' && <>:{databaseKey.proxy_port}</>}</div>}
                        <div className='t-data-double'>
                            <div className='t-data-block'>{(databaseKey.comment ?? "")}</div>
                            <div className='t-data-block'>{databaseKey.configuration.server}:{databaseKey.configuration.server_port}</div>
                        </div>
                        <TButton onClick={() => setMigrationOverlayOpened(true)} text={"Миграция"} />
                        {migrationHistory.length > 0 && <div style={{ paddingBottom: '120px' }}>
                            <Heading icon={'📜'} text={'История Миграций'} />
                            <div className='migrations-list'>
                                {migrationHistory.map((historyItem) => {
                                    return <div className='t-data-block migration-item'><span style={{ color: "rgba(255, 255, 255, 0.5)", fontSize: '14px' }}>{new Date(historyItem.created_at).toLocaleString()}</span><br /> {historyItem.from_server_comment} → {historyItem.to_server_comment}</div>
                                })}
                            </div>
                        </div>}
                    </div>
                </div></>)
    }

    if (pageState === 'search') {
        return <>
            <div className="content-block t-container">
                <div className="t-content split">
                    <div className="page-header">
                        <h1>Поиск ключа Outline / Vless</h1>
                    </div>
                    <input
                        value={userKeyID}
                        placeholder="https://key.simplesmm.org/XXXX OR bot.simplesmm.org"
                        onChange={validateUserKey}
                        type="text"
                        className="t-input"
                    ></input>
                    <button
                        className="t-button"
                        onClick={(e) => {
                            e.preventDefault();
                            searchKey();
                        }}
                    >
                        Найти ключ
                    </button>
                </div>
            </div>
        </>
    }

}
